import React, { FC, useCallback, useState } from 'react';
import type { PhotoAlignmentX, PhotoAlignmentY, WebsitePhotoAlignment } from '@shared/types/WebsiteHeaderSettings.types';
import { PhotoXPosition, PhotoYPosition } from '@graphql/generated';
import { PhotoAlignment } from '@shared/components/MultiPhotoSelector/components/PhotoAlignmentDialog/PhotoAlignmentDialog';
import { ImageData } from '@shared/components/MultiPhotoSelector/MultiPhotoSelector.types';
import { MediaPhoto } from '../../PhotoPickerDialog.types';

type PhotoAlignmentSelectorProps = Readonly<{
  selectedPhoto: MediaPhoto;
  alignment?: WebsitePhotoAlignment;
  handleFocusPointSelect: (alignment: WebsitePhotoAlignment) => void;
}>;

export const PhotoAlignmentSelector: FC<PhotoAlignmentSelectorProps> = props => {
  const { selectedPhoto, alignment, handleFocusPointSelect } = props;
  const [focusPoint, setFocusPoint] = useState<WebsitePhotoAlignment>({ alignX: alignment?.alignX || PhotoXPosition.center, alignY: alignment?.alignY || PhotoYPosition.center });

  const handleFocusPointChange = useCallback(
    (alignX: PhotoAlignmentX, alignY: PhotoAlignmentY) => {
      setFocusPoint({ alignX, alignY });
      handleFocusPointSelect({ alignX, alignY });
    },
    [handleFocusPointSelect],
  );

  const imageData: ImageData = {
    id: selectedPhoto.id,
    url: selectedPhoto.photo.url,
    height: selectedPhoto.photo.height,
    width: selectedPhoto.photo.width,
  };

  return (
    <PhotoAlignment
      focusPoint={focusPoint}
      handleFocusPointChange={handleFocusPointChange}
      imageData={imageData}
    />
  );
};
